import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Select, Store } from '@ngxs/store';
import { ScoredSubscription, PatientEntity, NetworkMember, Time, CommonService, Config, CompassStateModel, BulkSubscription, BulkSubscriptionAssignment, GetBulkSubscriptionAssignments, FamilyEntity } from 'huddyapi';

import moment_ from 'moment';
import { Observable, timer } from 'rxjs';
import { DocumentsDialog } from '../../components/documents/documents-dialog';
import { EditAssignmentDialog } from '../../components/edit-assignment-dialog/edit-assignment-dialog.component';
import { CommunityConfigService } from '../../services/community-config.service';
import { Assessment } from '../assessment/assessment';
import { LoggingDetailDialog } from '../logging-detail-dialog/logging-detail-dialog';


const moment = moment_;

@Component({
  selector: 'compass-tab',
  templateUrl: './compass-tab.component.html',
  styleUrls: ['./compass-tab.component.scss']
})
export class CompassTabComponent implements OnInit {

  @Input() patient : PatientEntity;
  @Input() scoredCompasses : ScoredSubscription[];
  @Input() family : FamilyEntity;
  @Output() editingDone: EventEmitter<void> = new EventEmitter<void>();

  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;

  bulkSubcriptions : BulkSubscription[];
  userAssignments : BulkSubscriptionAssignment[];
  familyAssignments : BulkSubscriptionAssignment[];
  constructor(
    private store : Store,
    private config: Config,
    private commonService : CommonService,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer
  ) {

    this.matIconRegistry.addSvgIcon('lib_books',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/library_books.svg'));
  }

  ngOnInit(): void {
   
    this.compassState$.subscribe((model: CompassStateModel) => {
      this.bulkSubcriptions = model.subscriptions;
      this.userAssignments = model.userAssignments;
      this.familyAssignments = model.familyAssignments;
      console.log('Got assignments', this.userAssignments, this.familyAssignments);
    });
    if (this.family) {
      this.store.dispatch(new GetBulkSubscriptionAssignments(null, 0, this.family.id));
    } else {
       this.store.dispatch(new GetBulkSubscriptionAssignments(null, this.patient.userId));
    }
  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (fromPatient) {
      name = 'p';
      if (this.patient && this.patient.lastName) {
        name = this.patient.lastName;
      }
    }
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }
  epochDayToDate(epochDay: number) : string {
    return epochDay && epochDay > 0 ?   Time.fromEpochDay(epochDay).getDateDisplay() : '';
  }


  getLetters(name: string): string {
    name = name.trim();
    return name.substring(0, 1);
  }


  showAssessmentOrEdit(scoredCompass : ScoredSubscription) {
  
    if (!scoredCompass) {
      scoredCompass = new ScoredSubscription();
    }

    if (!scoredCompass.lastAssessmentDay || scoredCompass.lastAssessmentDay <= 0) {
      this.editAssignment(scoredCompass);
    } else if (CommonService.jwt && CommonService.jwt.length > 7) {
      let token : string = CommonService.jwt.substring(7);
      let url : string = this.config.getEndpoint() + '/report-for-subscription?subscriptionId=' + scoredCompass.guidanceSubscriptionId + '&access_token=' + token;
      window.open(url);      
    }
  }


  getPatientName(patient? : PatientEntity) : string {
    let ret : string = patient ? patient.firstName + ' ' + patient.lastName : this.patient.firstName + ' ' + this.patient.lastName;
    if (!ret || ret.indexOf("null ") > -1) {
      ret = patient ? patient.username : this.patient.username;
    }
    return ret;
  }

  showDocuments(scoredSubscription : ScoredSubscription) {

    let data = {
      contextId : scoredSubscription.assignmentId,
      contextType : 'ASSIGNMENT',
      providerId : this.family ? this.family.patients[0].patient.providerId : this.patient.providerId
    }

    this.dialog.open(DocumentsDialog, {
      width: '600px',
      height: '500px',
      data: data
    });
  }

  getVersion(bulkSubscriptionid : number) : number {
    let ret : number = 1;
    const sub : BulkSubscription = this.bulkSubcriptions.find(v => v.id === bulkSubscriptionid);
    if (sub) {
      ret = sub.compass.version;
    }
    return ret;
  }
  editAssignment(scoredCompass : ScoredSubscription) {
    console.log('entering editAssignment', this.patient);
    if (scoredCompass && scoredCompass.lastAssessmentDay && scoredCompass.lastAssessmentDay > 0) {
      return;
    }
    console.log('editAssignment', this.family, scoredCompass);
    let patient : PatientEntity = undefined;
    if (scoredCompass) {
      patient = this.family ? 
          this.family.patients.find(p => p.patient.userId === scoredCompass.userId).patient : 
          this.patient;
    } else if (this.patient) {
      patient = this.patient;
    }
  
   
    let data = {
      mode : 'patient',
      patientId : patient ? patient.id : undefined,
      assessmentTakerEmail : scoredCompass ? scoredCompass.assessmentTakerEmail :  patient ? patient.username : this.commonService.getCurrentUserToView(),
      assignedDt :  new Date(),
      assignedBy :   this.commonService.getCurrentUserToView(),
      compassId : scoredCompass ? scoredCompass.compassId : -1,
      patientUsername : patient ?  patient.username : undefined,
      bulkSubscriptionId : scoredCompass ? scoredCompass.bulkSubscriptionId : -1,
      bulkSubscriptionAssignmentId: scoredCompass ? scoredCompass.assignmentId : -1,
      guidanceSubscriptionId : scoredCompass ? scoredCompass.guidanceSubscriptionId : -1,
      subjectScoreLevel : scoredCompass? scoredCompass.scoreReportingLevel : 'DETAILED',
      patientFriendlyName : patient  ? this.getPatientName(patient) : '' ,
      patientUserId : patient ? patient.userId : undefined,
      family : this.family
    }
    console.log('editAssignment', data);
    const editDialog = this.dialog.open(EditAssignmentDialog, {
      width: '700px',
      height: '350px',
      data: data
    });
    editDialog.afterClosed().subscribe(t => this.editingDone.emit());

  }

  userIsAssessmentTaker(scoredSubscription: ScoredSubscription) {
    return scoredSubscription.assessmentTakerEmail === CommonService.currentUserToView;
  }

  takeAssessment(scoredSubscription : ScoredSubscription) {
    let data = {
      subscription: scoredSubscription,
      familyId : this.family ? this.family.id : undefined,
      patientId : this.family ? undefined : this.patient.id
    } 
    console.log('editAssignment', data);
    const assementDialog = this.dialog.open(Assessment, {
      width: '700px',
      height: '700px',
      data: data
    });
    assementDialog.afterClosed().subscribe(t => 
      timer(5000).subscribe(t => this.editingDone.emit())
    );

  }
  log(scoredSubscription : ScoredSubscription) {
    let data = {
      subscription: scoredSubscription,
      familyId : this.family ? this.family.id : undefined,
      patientId : this.family ? undefined : this.patient.id
    } 
    console.log('log', data);
    const loggingDialog = this.dialog.open(LoggingDetailDialog, {
      width: '700px',
      height: '700px',
      data: data
    });
    loggingDialog.afterClosed().subscribe(t => 
      timer(5000).subscribe(t => this.editingDone.emit())
    );

  }

}